import { useState } from "react";
import { Button } from "@mui/material";
import ApiService from "../../../modules/APIService.interceptors";
import { useNotifier } from "../../../hooks/useNotifier";
import ConfirmActionDialog from "./ConfirmActionDialog";

const DISABLE_PHONE_DIALOG_DESCRIPTION = (
  <>
    Esta acción <strong>quita la verificación</strong> del teléfono y <strong>borra el número</strong>{" "}
    guardado para este usuario. No se puede deshacer desde aquí salvo que vuelvas a cargar un número
    nuevo.
  </>
);

const DISABLE_PHONE_DIALOG_CONFIRM_PROMPT = "¿Confirmás que querés continuar?";

const NULL_PHONE = null;

const NOT_VERIFIED = false;

const DisablePhoneButton = ({ userId, setPhone_verified }) => {
  const notify = useNotifier();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    if (!loading) setOpen(false);
  };

  const handleConfirm = async () => {
    if (!userId) return;
    try {
      setLoading(true);
      await ApiService.updateUser(userId, {
        phone: NULL_PHONE,
        phone_verified: NOT_VERIFIED,
      });
      setPhone_verified(false);
      setOpen(false);
      notify("Número deshabilitado correctamente", "success");
    } catch {
      notify("Error al deshabilitar el número", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant="outlined" color="error" size="small" onClick={handleOpen} disabled={!userId}>
        Deshabilitar número
      </Button>

      <ConfirmActionDialog
        open={open}
        onClose={handleClose}
        title="Deshabilitar número de teléfono"
        description={DISABLE_PHONE_DIALOG_DESCRIPTION}
        confirmPrompt={DISABLE_PHONE_DIALOG_CONFIRM_PROMPT}
        onConfirm={handleConfirm}
        loading={loading}
        confirmColor="error"
      />
    </>
  );
};

export default DisablePhoneButton;
